<template>
    <div class="maintenance">
        <div class="header-logo">
            <p class="img-logo"><a href="/"><img src="../../../../images/top/sensei_logo.png" class="img-logo img-logo-resize" alt="レガシィマネジメントグループ"></a></p>
        </div>
        <div class="description">
            <p class="lead">ただいまメンテナンス中です</p>
            <p class="detail">
                現在、システムのメンテナンス中です。<br>
                ご不便をおかけしますが、ご理解の程お願い申し上げます。<br>
            </p>
            <div class="duration">
                <div class="duration__title">メンテナンス期間</div>
                <div class="duration__value">2022年4月26日(火) 11:30 ～ 12:30</div>
                <div class="duration__notice">※作業進捗により、前後する場合がございます。</div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        mounted () {
            if (!this.isMaintenance) {
                this.$router.push({ name: 'home' })
            }
        },
        computed: {
            ...mapGetters(['isMaintenance'])
        }
    }
</script>
<style scoped>
  @import 'maintenance.css';
</style>
